// Pure breadcrumb model for the reader. No DOM, no React. Builds the path
// trail the reader renders — a leading workspace crumb
// then one crumb per path segment with cumulative `target` paths; the last
// crumb is `isCurrent` (non-clickable). Empty/null filePath → workspace crumb
// only (it is then the current). No workspace label → [].
export function buildBreadcrumbItems(workspaceLabel, filePath) {
  if (!workspaceLabel) return [];
  const segs = filePath ? filePath.split('/').filter(Boolean) : [];
  const items = [
    { label: workspaceLabel, target: null, isWorkspace: true, isCurrent: segs.length === 0 },
  ];
  let cum = '';
  segs.forEach((seg, i) => {
    cum = cum ? `${cum}/${seg}` : seg;
    items.push({
      label: seg,
      target: cum,
      isWorkspace: false,
      isCurrent: i === segs.length - 1,
    });
  });
  return items;
}
